import React, { Component } from 'react';

export default class ViewingDay extends Component {
  get classes() {
    const classes = ['book-a-viewing__day_choice', 'day'];

    if (this.props.selected) {
      classes.push('selected');
    }

    return classes.join(' ');
  }

  handleClick = (e) => {
    e.preventDefault();
    track_event('booking-day', 'clicked', 'bookings');

    this.props.onClick(e);
  };

  render() {
    const day = this.props.day;
    if (day.isDisabled) {
      return (
        <span className="book-a-viewing__day_choice day disabled">
          <span className="text">{day.weekdayLabel}</span>
          <span className="number">{day.dayLabel}</span>
        </span>
      );
    } else {
      return (
        <a
          className={this.classes}
          id={`day-${day.date}`}
          data-date={`day-${day.date}`}
          data-ga-category="home-viewing-flow"
          data-ga-action="select-viewing-day"
          data-ga-label={`${day.weekdayLabel} ${day.dayLabel}`}
          onClick={this.handleClick}
        >
          <span className="text">{day.weekdayLabel}</span>
          <span className="number">{day.dayLabel}</span>
        </a>
      );
    }
  }
}
